import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../../../basics/Typography/Typography.js';
import StyledControls from './Controls.style.js';

const Controls = ({
  handleChange,
  currentIndex,
  currentCaption,
  numberOfBullets
}) => /*#__PURE__*/React$1.createElement(StyledControls, null, currentCaption && /*#__PURE__*/React$1.createElement(Typography$1, {
  className: "controls__caption"
}, currentCaption), Array.from(Array(numberOfBullets).keys()).map((item, i) => /*#__PURE__*/React$1.createElement("button", {
  key: item,
  type: "button",
  onClick: () => handleChange(item),
  "aria-label": `Go to slide ${item + 1}`
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "span",
  className: currentIndex === item ? 'is-active' : '',
  variant: "copyIntro"
}, i + 1))));

Controls.propTypes = {
  handleChange: PropTypes$1.func.isRequired,
  numberOfBullets: PropTypes$1.number.isRequired,
  currentIndex: PropTypes$1.number.isRequired,
  currentCaption: PropTypes$1.string
};
Controls.defaultProps = {
  currentCaption: ''
};

export default Controls;
